import script from "./PdfReader.vue?vue&type=script&setup=true&lang=js"
export * from "./PdfReader.vue?vue&type=script&setup=true&lang=js"

import "./PdfReader.vue?vue&type=style&index=0&id=200937c9&scoped=true&lang=css"

import exportComponent from "/root/buildarea/v8-development-frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-200937c9"]])

export default __exports__